import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import "firebase/firestore";

const config = {
    apiKey: "AIzaSyAApK6yHSRg1T0kw1lmSzcYviTl7NPf630",
    authDomain: "react-food-blog.firebaseapp.com",
    databaseURL: "https://react-food-blog.firebaseio.com",
    projectId: "react-food-blog",
    storageBucket: "react-food-blog.appspot.com",
    messagingSenderId: "148516209111",
    appId: "1:148516209111:web:79d50e6dd9e2af3c834b92",
    measurementId: "G-0KCHE78X33"
};
firebase.initializeApp(config);

const storage = firebase.storage()


export  {
    storage, firebase as default
  }
 
 
